// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__nw0Iy","content":"GlobalSearch_content__1fsL2"};